module.exports = __webpack_public_path__ + "img/a_exerices.055bff3e.png";